module.exports = __webpack_public_path__ + "img/main_culture3.75478786.png";